import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanDTO } from 'src/app/models/PlanDTO.model';
import { PlanService } from 'src/app/services/plan.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';
import { ResponseBase } from 'src/app/models/ResponseBase';
import { TableColumn } from 'src/app/models/TableColumn';
import { CellPlanStatusToggleComponent } from './cell-plan-status-toggle/cell-plan-status-toggle.component';

import { CommonModule } from '@angular/common';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
declare var bootstrap: any;

@Component({
    selector: 'app-list-plans',
    templateUrl: './list-plans.component.html',
    styleUrls: ['./list-plans.component.css'],
    imports: [CommonModule, TableControlComponent, TooltipDirective]
})
export class ListPlansComponent {
  @Output()
  showCreatePlan: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  showUpdatePlan: EventEmitter<number> = new EventEmitter<number>();

  plans: PlanDTO[] = [];
  plansArchived: any[] = [];
  plansAll: any[] = [];
  filterValue: string = 'option1';
  currentPage: number = 1;
  totalPages: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';

  originalPlan: any[] = [];
  selectedPlan: any;
  isFilteredByStatus: boolean = false;
  originalPlans: any[] = [];
  recordsPerPage: number = 10;
  alert: Alert = {} as Alert;


  columns: TableColumn[] = [
    { key: 'planID', header: 'Plan ID' },
    { key: 'planName', header: 'Name', width: 250 },
    { key: 'planTypeName', header: 'Plan Type', width: 250 },
    {
      key: 'frequencyId', header: 'Billing Frequency',
      format: {
        type: 'custom',
        customFormatter: (value: any, row: any) => {
          return row.planType ? row.planType.frequencyId : '';


        }
      }
    },
    {
      key: 'qtyData', header: 'Data',
      format: {
        type: 'custom',
        customFormatter: (value: any, row: any) => {
          return value.toFixed(2) + ' ' + row.typeData;
        }
      }
    },
    {
      key: 'price', header: 'Price', format: {
        type: 'currency',
        currencySymbol: '$', decimalPlaces: 2
      }
    },
    { key: 'description', header: 'Description' },
    {
      key: 'Carriers', header: 'Carriers',
      format: {
        type: 'custom',
        customFormatter: (value: any, row: any) => {

          if (row.planCarriers && row.planCarriers.length > 0) {
            return row.planCarriers.map((carrier: any) => carrier.carrierName).join(', ');
          }
          return 'No Carriers';
        }
      }
    },
    {
      key: 'Pool', header: 'Pool',
      format: {
        type: 'custom',
        customFormatter: (value: any, row: any) => {

          if (row.planType.isPool) {
            
            return 'True';
          }
          return 'False';

        }
      }
    },

    {
      key: 'state', header: 'Status', renderComponent: CellPlanStatusToggleComponent, onClick: (event, value, row) => {
        
        this.toggleStatus(event, row);
        this.setSelectedPlan(row);
        this.openConfirmationModal(row);
      }
    },
  ];

  actionButtons = [

    { label: 'edit', tooltip: 'Edit Plan', class: 'primary', icon: 'bi bi-pencil-square' },
    { label: 'archive', tooltip: () => this.isFilteredByStatus ? 'Restore Plan' : 'Archive Plan', class: () => this.isFilteredByStatus ? 'primary' : 'danger', icon: 'bi bi-archive' },
    { label: 'view', tooltip: 'View Plan', class: 'info', icon: 'bi bi-eye' },
  ];
  constructor(
    private PlanService: PlanService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) { }

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Plans);

    this.PlanService.getAllPlans().subscribe(
      (reponse: PlanDTO[]) => {

        this.HandleGetListPlans(reponse);

      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }


  onAction(event: { action: string; item: PlanDTO }): void {

    switch (event.action) {
      case 'edit':
        this.editPlan(event.item.planID);
        break;
      case 'archive':
        this.setArchivedPlan(event.item);
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modalArchive')).show();
        break;
      case 'view':
        this.navigateToPlansView(event.item);
        break;
    }
  }







  HandleGetListPlans(plans: PlanDTO[]) {
    this.plans = plans.filter(plan => plan.state != 2);
    this.plansArchived = plans.filter(plan => plan.state == 2);
    this.plansAll = plans;
    // plans.forEach((plan) => {


    //   if (plan.state != 2) {
    //     this.plans.push(plan);
    //     this.plansAll.push(plan);
    //   } else {
    //     this.plansArchived.push(plan);
    //   }
    // });
    this.totalPages = Math.ceil(this.plans.length / 10);
  }

  HandleGetListPlansError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  showFormCreate() {
    this.showCreatePlan.emit(true);
  }

  goBack() {
    window.location.href = '/home';
  }

  editPlan(idPlan: any) {
    this.showCreatePlan.emit(true);
    this.showUpdatePlan.emit(idPlan);
  }

  // Metodo para actualizar el estado de un plan
  updatePlanStatus(confirmed: boolean) {
    if (confirmed) {
      this.PlanService.updatePlan(this.selectedPlan).subscribe(
        (reponse: ResponseBase) => {
          this.HandleUpdatePlanStatus();
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
        }
      );
    } else {
      location.reload();
    }
  }

  toggleStatus(event: any, plan: any) {
    plan.state = event.target.checked ? 1 : 0;
    const indice = this.originalPlan.findIndex(
      (plan) => plan.planID === plan.planID
    );
    if (indice !== -1) {
      this.originalPlan[indice].state = plan.state;
    }
  }

  setSelectedPlan(plan: any) {
    this.selectedPlan = plan;
  }

  openConfirmationModal(plan: any) {
    this.selectedPlan = plan;
  }

  async HandleUpdatePlanStatus() {
    this.alert = {
      alertMessage: 'Plan status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  HandleUpdatePlantatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  setArchivedPlan(plan: any) {
    this.selectedPlan = plan;
    this.selectedPlan.state = this.isFilteredByStatus ? 1 : 2;
  }

  filterByStatus(status: number) {
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalPlans = this.plansArchived.slice();
      this.isFilteredByStatus = true;
    } else {
      this.originalPlans = this.plansAll.slice();
      this.isFilteredByStatus = false;
    }

    this.plans = this.originalPlans.filter((plan) => plan.state === status);

  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.plans = this.originalPlans.slice(); // Restaura la lista original
  }

  navigateToPlansView(plan: any) {
    //console.log('navigate to plans view');
    console.log(plan);
    this.router.navigate(['/view-plans', plan.planID]);
  }

  exportPlansListToExcel() {
    this.PlanService.exportPlansListToExcel().subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }
}
